<template>
    <div class="page-wrapper v-cloak">
        <!-- CHUNKED WATCHES GRID VIEW WITH FEATURED WATCHES BETWEEN CHUNKS 1ST 2ND AND 3RD -->

        <div class="page-grid-wrapper">
            <div class="page-grid-fix">
                <h2>Latest arrivals</h2>
                <h4 style="width: 400px;">{{ siteSettings.other_watches_lead }}</h4>

<!-- FILTERS AND SEARCH -->
    <!-- FILTERS AND SEARCH -->
        <div class="search-and-filters">
          <div class="fs-toggles">
            <div @click="toggleSearch" class="search-toggle-btn search-icon">
              <img v-if="searchedWatches.length > 0" class="center" src="/images/icons/loupe-gold.svg" />
              <img v-else class="center" src="/images/icons/loupe-blk.svg" />
            </div>
            <div @click="toggleFilters" class="filters-toggle-btn filter-icon">
              <img v-if="filtersActive" class="center" src="/images/icons/filters-active.svg" />
              <img v-else class="center" src="/images/icons/filters-blk.svg" />
            </div>
          </div>

          <!-- SEARCH TRAY -->
          <div :class="['search-tray', { open: showSearch }]">
            <SearchComponent
              :items="watches"
              :showSearch="showSearch"
              @search-results="handleSearchResults"
              @closeSearch="showSearch = false"
            />
            <a class="close-search" @click="toggleSearch">Close</a>

            <div v-if="searchedWatches.length" :class="['search-count', { alert: searchedWatches.length === 0 }]">
              {{ searchedWatches.length }} watch{{ searchedWatches.length === 1 ? '' : 'es' }} match{{ searchedWatches.length === 1 ? 'es' : '' }} your criteria.
            </div>

            <div v-if="searchedWatches.length > 0" class="list-grid-toggle view-icon" @click="toggleView">
              <img v-if="gridView" class="center" src="/images/icons/list-view-icon.svg" />
              <img v-else class="center" src="/images/icons/grid-view-icon.svg" />
            </div>

            <!-- SEARCH RESULTS -->
            <div class="search-results">
              <div v-if="gridView" class="grid-view">
                <span v-for="watch in searchedWatches" :key="watch.SKU">
                  <router-link :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">
                    <figure class="image-container">
                      <img loading="lazy" class="imageGridSource" @error="imageLoadError" :src="alternativeImageGridSource(watch)" alt="" />
                      <figcaption>
                        <span>{{ watch.Model }}</span><br />
                        <span>Available in {{ watch.WatchLocation }}</span>
                      </figcaption>
                    </figure>
                  </router-link>
                </span>
              </div>

              <ul v-else class="list-view">
                <li v-for="watch in searchedWatches" :key="watch.SKU">
                  <div class="search-list-container">
                    <figure class="image-container">
                      <img loading="lazy" style="width: 150px;" class="imageGridSource" @error="imageLoadError" :src="alternativeImageGridSource(watch)" alt="" />
                      <figcaption>
                        <router-link :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">
                          <h4>{{ watch.ManufacturerName }} {{ watch.Model }}</h4>
                        </router-link>
                        <p>Material: {{ watch.Material }}</p>
                        <p>Year: {{ watch.Year }}</p>
                        <p v-if="watch.StatusName === 'Sold'">Sold</p>
                        <p v-if="watch.StatusName === null || watch.StatusName === 'on hold'">In Stock</p>
                        <p v-if="watch.StatusName === 'deposit'">On Deposit</p>
                        <p v-else>
                          {{ watch.StatusName }}&nbsp;&nbsp;|&nbsp;
                          <span v-if="watch.isPOA" class="price">POA</span>
                          <span v-else class="price">{{ watch.currencySymbol }} {{ watch.displayPrice }}</span>
                        </p>
                        <p class="appointment-at-location">
                          <strong>Available</strong> for appointments at our
                          <router-link :to="{ path: '/locations', query: { location: watch.WatchLocation } }">{{ watch.WatchLocation }}</router-link>
                          boutique
                        </p>
                      </figcaption>
                      <button @click="openPopup(watch.SKU)">Enquire Now</button>
                    </figure>
                  </div>

                  <div v-if="activePopup === watch.SKU" class="popup-overlay" @click.self="closePopup">
                    <div class="popup">
                      <a class="close-btn" @click="closePopup">Close</a><br />
                      <h4>Enquiry about {{ watch.ManufacturerName }} {{ watch.Model }}</h4>
                      <EnquiryForm :Model="watch.Model" :SKU="watch.SKU" formOrigin="Richard Mille - Search" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- FILTERS TRAY -->
          <div :class="['filters-tray', { open: showFilters }]">
            <FiltersComponent
              ref="filtersComponent"
              :filterOptions="dynamicFilters"
              :filterCount="filteredWatches.length"
              @filters-active="handleFiltersActive"
              @filter-changed="handleFilterChange"
              @close-filters="toggleFilters"
            />
          </div>
        </div>
        
                <div v-if="this.filtersActive && !this.showFilters" class="filters-applied"> ACTIVE FILTERS 
                    <br><span>{{ displayAppliedFilters }}</span><br>
                    <span  v-if="this.filtersActive && !this.showFilters" class="buttons-inline">
                         <button @click="passResetFilters">Clear Filters</button> <button @click="toggleFilters" class="filters-toggle-btn filter-icon">Refine Filters</button>
                    </span>
                </div>
<!-- END of FILTERS AND SEARCH -->

<!-- GRID VIEW  -->



        <div v-for="(watchesChunk, index) in allWatches" :key="index">
          <div class="watches">
            <div class="grid-view array-chunk" v-if="filteredWatches.length">
              <div v-for="watch in watchesChunk" :key="watch.SKU" class="grid-item watch__card" ref="card">
                <div class="watch__card-content">
                  <router-link :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">
                    <figure class="image-container">
                      <img loading="lazy" class="imageGridSource" :src="imageGridSource(watch)" @error="handleImagePlaceholder" alt="" />
                      <img loading="lazy" class="alternativeImageGridSource" @error="imageLoadError" :src="alternativeImageGridSource(watch)" alt="" />
                      <figcaption>
                        <p>{{ watch.ManufacturerName }} {{ watch.Model }}</p>
                      </figcaption>
                      <figcaption>
                        <span v-if="watch.StatusName === 'Sold'">Sold</span>
                        <span v-if="watch.StatusName === null || watch.StatusName === 'on hold'" class="status">In Stock</span>
                        <span v-if="watch.StatusName === 'deposit'" class="status">On Deposit</span>
                        <span v-else class="status">
                          {{ watch.StatusName }}&nbsp;&nbsp;|&nbsp;
                          <span v-if="watch.isPOA" class="price">POA</span>
                          <span v-else class="price">{{ watch.currencySymbol }} {{ watch.displayPrice }}
                             <br>
                            <span class="exc-taxes" v-if="watch.MarginScheme == '1'">&nbsp;exc.&ensp;taxes </span>
                          </span>
                         
                        </span>
                        <div class="learn-more">View <img class="center" src="/images/icons/ArrowRight.svg" /></div>
                      </figcaption>
                    </figure>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="featured-watches" v-if="[0,1,2,3].includes(index)">
            <FeaturedWatches :loop="index" :route="showRoute" />
          </div>
        </div>


















                <!-- <div class="watches">
                    <div class="grid-view" v-if="filteredWatches.length">
                        <div v-for="watch in (searchTerm ? searchResults : filteredWatches)" :key="watch.SKU" class="grid-item watch__card" ref="card">
                            <div class="watch__card-content">
                                <router-link v-if="watch.ManufacturerName === 'Richard Mille'"
                                    :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">

                                    <figure class="image-container">
                                            <img class="imageGridSource" :src="imageGridSource(watch)" alt="" :key="watch.SKU">
                                            <img class="alternativeImageGridSource" @error="imageLoadError" :src="alternativeImageGridSource(watch)" alt="">

                                        <figcaption>
                                            <p>{{ watch.ManufacturerName }} {{ watch.Model }}</p>
                                        </figcaption>

                                        <figcaption>
                                            <span v-if="watch.StatusName === 'Sold'">Sold</span>
                                            <span v-if="watch.StatusName === null" class="status">In Stock</span>
                                            <span v-if="watch.StatusName === 'on hold'" class="status">In Stock</span>
                                            <span v-if="watch.StatusName === 'deposit'" class="status">On Deposit</span>
                                            <span v-else class="status">{{ watch.StatusName }}&nbsp;&nbsp;|&nbsp;
                                                <span class="price" v-if="Number(watch.Price) > Number(siteSettings.poa_price_tag)">POA</span>
                                                <span v-else class="price">
                                                    <span v-if="watch.Currency === '£'">£&nbsp; </span>
                                                    <span v-if="watch.Currency === 'CHF'">CHF&nbsp;</span>
                                                    <span v-if="watch.Currency === 'USD'">$&nbsp;</span>
                                                    <span v-if="watch.Currency === 'AED'">AED&nbsp;</span>
                                                    <span v-if="!watch.Currency">£&nbsp;</span>
                                                    {{ $formatNumber(watch.Price) }}
                                                    </span>
                                            </span>
                                            
                                            <div class="learn-more">   
                                                View <img class="center" src="/images/icons/ArrowRight.svg">
                                            </div>
                                        </figcaption>
                                    </figure>
                                </router-link>

                                <router-link v-else
                                    :to="{ name: 'otherwatch', params: {  watchManufacturerName: watch.ManufacturerName.split(' ').join('-'), watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">
                                    <figure class="image-container">
                                            <img class="imageGridSource" :src="imageGridSource(watch)" @error="handleImagePlaceholder" alt="" :key="watch.SKU">
                                        <figcaption>
                                            <p>{{ watch.ManufacturerName }} {{ watch.Model }}</p>
                                        </figcaption>
                                        <figcaption>
                                            <span v-if="watch.StatusName === 'Sold'">Sold</span>
                                            <span v-if="watch.StatusName === null" class="status">In Stock</span>
                                            <span v-if="watch.StatusName === 'on hold'" class="status">In Stock</span>
                                            <span v-if="watch.StatusName === 'deposit'" class="status">On Deposit</span>
                                            <span v-else class="status">{{ watch.StatusName }}&nbsp;&nbsp;|&nbsp;
                                                <span class="price" v-if="Number(watch.Price) > Number(siteSettings.poa_price_tag)">POA</span>
                                                <span v-else class="price">
                                                    <span v-if="watch.Currency === '£'">£&nbsp; </span>
                                                    <span v-if="watch.Currency === 'CHF'">CHF&nbsp;</span>
                                                    <span v-if="watch.Currency === 'USD'">$&nbsp;</span>
                                                    <span v-if="watch.Currency === 'AED'">AED&nbsp;</span>
                                                    <span v-if="!watch.Currency">£&nbsp;</span>
                                                    {{ $formatNumber(watch.Price) }}
                                                    <br>
                                                    <span class="exc-taxes" v-if="watch.MarginScheme == '1'">&nbsp;exc.&ensp;taxes </span>
                                                    </span>
                                            </span>
                                            
                                            <div class="learn-more">   
                                                View <img class="center" src="/images/icons/ArrowRight.svg">                                                    
                                            </div>
                                        </figcaption>
                                    </figure>

                                </router-link>
                            </div>
                        </div>
                    </div>
                </div> -->

















            </div>
        </div>
        <!-- END CHUNKED WATCHES GRID VIE WITH FEATURED WATCHES BETWEEN CHUNKS 1ST 2ND AND 3RD -->

        <!--NO SEARCH RESULT ALERT -->
        <div class="space-helper"></div>
        <div class="page-grid-wrapper">
            <div class="page-grid-fix">
                <div v-if="!filteredWatches.length && delayForm" class="no-search-results">
                    <h2>Unfortunately we can’t find what you are looking for right now</h2>
                    <p>Please Contact Us to Register Your Interest</p>
                    <form>
                        <ContactForm></ContactForm>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import ContactForm from '../components/ContactForm.vue';
import FeaturedWatches from '../components/FeaturedWatches.vue'; 
import EnquiryForm from '../components/EnquiryForm.vue';
import FiltersComponent from '../components/FiltersComponent.vue';
import SearchComponent from '../components/SearchComponent.vue';
import axios from 'axios';
import _ from 'lodash';

export default {
  name: 'WatchesOrderedComponent',
  components: { ContactForm, EnquiryForm, FeaturedWatches, FiltersComponent, SearchComponent },
  props: ['featuredRM'],
  data() {
    return {
      watches: [],
      watchessold: [],
      filteredWatches: [],
      searchedWatches: [],
      dynamicFilters: {},
      appliedFilters: {},
      showSearch: false,
      showFilters: false,
      filtersActive: false,
      gridView: false,
      activePopup: null,
      showRoute: this.$route.name,
      watchesOrderedCancelToken: null,
      watchesSoldCancelToken: null,
      delayForm: false,
      routeChangeTimeout: null
    };
  },
  mounted() {
    this.getWatchesOrdered();
    // this.getWatchesSold();
    setTimeout(() => this.delayForm = true, 2000);
  },
  watch: {
    '$route.name'(newName) {
      this.showRoute = newName;

      if (this.watchesOrderedCancelToken) this.watchesOrderedCancelToken.cancel('Route changed.');
      if (this.watchesSoldCancelToken) this.watchesSoldCancelToken.cancel('Route changed.');

      clearTimeout(this.routeChangeTimeout);
      this.routeChangeTimeout = setTimeout(() => {
        this.getWatchesOrdered();
        // this.getWatchesSold();
      }, 200);
    }
  },
    methods: {
        async getWatchesOrdered(address) {
        // Cancel the previous request if it exists
        if (this.watchesOrderedCancelToken) {
            this.watchesOrderedCancelToken.cancel('Request canceled due to a new request or route change.');
        }

        // Create a new cancel token for this request
        this.watchesOrderedCancelToken = axios.CancelToken.source();
        const cancelToken = this.watchesOrderedCancelToken.token; // Store the token for use in the request

        try {
            const response = await this.$axios.get(address ? address : "/api/watches", {
                cancelToken // Pass the cancel token to the request
            });

            // Check if the request was canceled *before* processing the response
            if (cancelToken.reason) { // Check if the request was canceled
                console.log('Request was canceled before processing the response.');
                return; // Exit the function early
            }

            this.watches = response.data.data;
            this.updateDynamicFilters();
            this.filteredWatches = this.watches;

            this.$emit("route-data-ready"); // tells App.vue to hide loader
            
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);
                // Handle the cancellation (e.g., reset loading state, show a message)
            } else {
                console.error("Error fetching watches:", error);
                // Handle other errors (e.g., display an error message, set an error flag)
            }
        }
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    handleSearchResults(searchResults) { this.searchedWatches = searchResults; },
    toggleFilters() { if (this.showSearch) this.showSearch = false; this.showFilters = !this.showFilters; },
    toggleSearch() { if (this.showFilters) this.showFilters = false; this.showSearch = !this.showSearch; },
    toggleView() { this.gridView = !this.gridView; },
    openPopup(sku) { this.activePopup = sku; },
    closePopup() { this.activePopup = null; },
    passResetFilters() { if (this.$refs.filtersComponent) this.$refs.filtersComponent.resetFilters(); },
    handleFiltersActive(isActive) { this.filtersActive = isActive; },
    handleFilterChange(selectedFilters) {
      this.appliedFilters = selectedFilters;
      const { locations = [], models = [], movements = [], materials = [] } = selectedFilters;
      this.filteredWatches = this.watches.filter(watch =>
        (!locations.length || locations.includes(watch.WatchLocation)) &&
        (!models.length || models.includes(watch.Model)) &&
        (!movements.length || movements.includes(watch.Movement)) &&
        (!materials.length || materials.includes(watch.WatchMaterial))
      );
    },
    updateDynamicFilters() {
      this.dynamicFilters = {
        locations: [...new Set(this.watches.map(w => w.WatchLocation))],
        models: [...new Set(this.watches.map(w => w.Model))],
        movements: this.getUniqueMovements(),
        materials: [...new Set(this.watches.map(w => w.WatchMaterial))]
      };
    },
    getUniqueMovements() {
      const set = new Set();
      this.watches.forEach(w => {
        if (w.Movement) {
          const clean = this.mapMovement(w.Movement);
          if (clean) set.add(clean);
        }
      });
      return [...set];
    },
    mapMovement(m) {
      const map = { 'Tourbillon':'Tourbillon', 'Automatic':'Automatic', 'Manual Winding':'Manual', 'Manual':'Manual', 'Quartz':'Quartz', 'Mechanical':'Manual', 'Barometer':'Barometer' };
      if (m.includes('Tourbillon')) return map['Tourbillon'];
      if (m.includes('Automatic') || m.includes('RM Automatic') || m.includes('AP Calibre')) return map['Automatic'];
      if (m.includes('Manual') || m.includes('Manual Calibre') || m.includes('Mechanical')) return map['Manual'];
      if (m.includes('Quartz')) return map['Quartz'];
      if (m.includes('Barometer')) return map['Barometer'];
      return null;
    },
    imageLoadError(e) { e.target.parentNode.removeChild(e.target); },
    handleImagePlaceholder(e) { if (e.target.dataset.fallbackApplied) return; e.target.dataset.fallbackApplied=true; e.target.src='/watches/gallery/maintenance/grid_placeholder.png'; },
    imageGridSource(w) { return `/watches/gallery/NW-${w.SKU}/grid-image/grid_NW-${w.SKU}.png`; },
    alternativeImageGridSource(w) { return `/watches/gallery/NW-${w.SKU}/grid-image/custom_grid_image_NW-${w.SKU}.jpg`; },
    noPngInSold(e,w) { if(e.target.dataset.fallbackApplied) return; e.target.dataset.fallbackApplied=true; e.target.src=`/watches/gallery/NW-${w.SKU}/grid-image/grid_NW-${w.SKU}.jpg`; }
  },
  computed: {
    displayAppliedFilters() {
      return Object.values(this.appliedFilters).flat().join(' ');
    },
    allWatches() { return _.chunk(this.filteredWatches, 6); },
  },
  beforeUnmount() {
    if (this.watchesOrderedCancelToken) this.watchesOrderedCancelToken.cancel('Component unmounted.');
    if (this.watchesSoldCancelToken) this.watchesSoldCancelToken.cancel('Component unmounted.');
    clearTimeout(this.routeChangeTimeout);
  }
};
</script>



<!-- 
<script>

import VuePagination from '../components/Pagination.vue';
import EnquiryForm from '../components/EnquiryForm.vue';
import ContactForm from '../components/ContactForm.vue';
import FiltersComponent from '../components/FiltersComponent.vue';
import SearchComponent from '../components/SearchComponent.vue';
import _ from 'lodash';
import axios from 'axios';

export default {
    name: 'WatchesOrderedComponent',
    components: {
        VuePagination,
        EnquiryForm,
        ContactForm,
        FiltersComponent,
        SearchComponent
    },

    watch: {
        '$route.name': function () {
            this.showRoute = this.$route.name;
        },
    },
    props: {
        siteSettings: {
            type: Object, // or Array, String, Boolean, etc.
            required: true // optional
        }
    },

    data() {
        return {
            window: {
                width: 0
            },
            windowWidth: window.innerWidth,
            images: {},
            selected: undefined,
            ShowInquiry: undefined,
            showRoute: {
                showRoute: this.$route.name
            },
            delayForm: false,
            watches: [], // Array to store fetched watches
            isLoading: false,
            // search and filters
            activePopup: null,
            dynamicFilters: {}, // Object to store dynamic filter options
            filteredWatches: [], // Array to store filtered watches
            searchedWatches: [],
            showFilters: false, // Flag to control the visibility of the filter tray
            showSearch: false,
            resetButtonTitle: 'Reset Filters', // Title for the reset button
            searchTerm: '',
            searchResults: [],
            gridView: false,
            filtersActive: false,
            appliedFilters: {}, // To store the applied filters
            watchesOrderedCancelToken: null,
        };
    },
    
    mounted() {
        window.onresize = () => {
            this.windowWidth = window.innerWidth
        },
        this.getWatchesOrdered();
        this.showRoute = this.$route.name;
        setTimeout(
            _ => this.delayForm = true, // render form
            2000 // after 2 second
        )
    },
    methods: {
        async getWatchesOrdered(address) {
        // Cancel the previous request if it exists
        if (this.watchesOrderedCancelToken) {
            this.watchesOrderedCancelToken.cancel('Request canceled due to a new request or route change.');
        }

        // Create a new cancel token for this request
        this.watchesOrderedCancelToken = axios.CancelToken.source();
        const cancelToken = this.watchesOrderedCancelToken.token; // Store the token for use in the request

        try {
            const response = await this.$axios.get(address ? address : "/api/watches", {
                cancelToken // Pass the cancel token to the request
            });

            // Check if the request was canceled *before* processing the response
            if (cancelToken.reason) { // Check if the request was canceled
                console.log('Request was canceled before processing the response.');
                return; // Exit the function early
            }

            this.watches = response.data.data;
            this.updateDynamicFilters();
            this.filteredWatches = this.watches;

            this.$emit("route-data-ready"); // tells App.vue to hide loader
            
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);
                // Handle the cancellation (e.g., reset loading state, show a message)
            } else {
                console.error("Error fetching watches:", error);
                // Handle other errors (e.g., display an error message, set an error flag)
            }
        }
    },

        
        updateWatches(results) {
            this.searchResults = results;
        },

        updateDynamicFilters() {
            this.dynamicFilters = {
                locations: [...new Set(this.watches.map(watch => watch.WatchLocation))],
                models: [...new Set(this.watches.map(watch => watch.Model))],
                movements: this.getUniqueMovements(),
                // materials: this.getUniqueMaterials()
                materials: [...new Set(this.watches.map(watch => watch.WatchMaterial))],
            };
        },

        getUniqueMovements() {
            const movementsSet = new Set();

            this.watches.forEach(watch => {
                const movement = watch.Movement;

                if (movement) {
                    const cleanMovement = this.mapMovement(movement);
                    if (cleanMovement) {
                        movementsSet.add(cleanMovement); // Add mapped movement to the set
                    }
                }
            });

            return [...movementsSet]; // Convert Set to Array
        },

        mapMovement(movement) {
            // Define mapping based on your requirements
            const movementMapping = {
                'Tourbillon': 'Tourbillon',
                'Automatic': 'Automatic',
                'Manual Winding': 'Manual',
                'Manual': 'Manual',
                'Quartz': 'Quartz',
                'Mechanical': 'Manual',
                'Barometer': 'Barometer'
            };

            // Handling specific cases
            if (movement.includes('Tourbillon')) return movementMapping['Tourbillon'];
            if (movement.includes('Automatic')) return movementMapping['Automatic'];
            if (movement.includes('Manual')) return movementMapping['Manual'];
            if (movement.includes('Quartz')) return movementMapping['Quartz'];
            if (movement.includes('Mechanical')) return movementMapping['Mechanical'];
            if (movement.includes('Barometer')) return movementMapping['Barometer'];

            // Check for specific caliber expressions
            if (movement.includes('RM Automatic') || movement.includes('AP Calibre')) {
                return movementMapping['Automatic'];
            }
            if (movement.includes('Manual Calibre')) {
                return movementMapping['Manual'];
            }

            // Default return if no match is found
            return null;
        },

        // handleFilterChange(selectedFilters) {
        //     this.appliedFilters = selectedFilters; // Update the applied filters
        //     const locations = selectedFilters.locations || [];
        //     const models = selectedFilters.models || [];
        //     const movements = selectedFilters.movements || [];
        //     const materials = selectedFilters.materials || [];

        //     this.filteredWatches = this.watches.filter(watch => {
        //         const locationMatch = locations.length ? locations.includes(watch.WatchLocation) : true;
        //         const modelMatch = models.length ? models.includes(watch.Model) : true;
        //         const movementMatch = movements.length ? this.getMovementMatch(movements, watch.Movement) : true;
        //         const materialMatch = materials.length ? materials.includes(watch.WatchMaterial) : true;
        //         return locationMatch && modelMatch && movementMatch && materialMatch; 
        //     });
        // },

        getMovementMatch(selectedMovements, movement) {
            if (!movement) return false; // If movement is null or undefined

            const cleanMovement = this.mapMovement(movement); // Use the mapping function

            return selectedMovements.includes(cleanMovement); // Check if the cleaned movement is in selected movements
        },
        
        handleFilterChange(selectedFilters) {
            this.appliedFilters = selectedFilters;
            const locations = selectedFilters.locations || [];
            const models = selectedFilters.models || [];
            const movements = selectedFilters.movements || [];
            const materials = selectedFilters.materials || [];

            this.filteredWatches = this.watches.filter(watch => {
                const locationMatch = locations.length ? locations.includes(watch.WatchLocation) : true;
                const modelMatch = models.length ? models.includes(watch.Model) : true;
                const movementMatch = movements.length ? movements.includes(watch.Movement) : true;
                const materialMatch = materials.length ? materials.includes(watch.WatchMaterial) : true;

                return locationMatch && modelMatch && movementMatch && materialMatch; 
            });
        },

        handleFiltersActive(isActive) {
            this.filtersActive = isActive;
        },

        passResetFilters() {
            if (this.$refs.filtersComponent) {
                this.$refs.filtersComponent.resetFilters();
            } else {
                console.error("filtersComponent is undefined.");
            }
        },

        handleSearchResults(searchResults) {
            this.searchedWatches = searchResults; 
        },

        toggleFilters() {
            // Hide search if it's currently visible
            if (this.showSearch) {
                this.showSearch = false;
            }
            // Toggle filters visibility
            this.showFilters = !this.showFilters;
        },

        toggleSearch() {
            // Hide filters if it's currently visible
            if (this.showFilters) {
                this.showFilters = false;
            }
            // Toggle search visibility
            this.showSearch = !this.showSearch;
        },
        toggleView() {
            this.gridView = !this.gridView;
        },
   
        imageLoadError(event) {
            event.target.parentNode.removeChild(event.target); // Remove the image from the DOM
        },
        imageGridSource(watch) {
            return '/watches/gallery/NW-' + watch.SKU + '/grid-image/grid_NW-'  + watch.SKU + '.png';
        },
        handleImagePlaceholder(event) {
            // Set the src to the placeholder image if the original image fails to load
            event.target.src = '/watches/gallery/maintenance/grid_placeholder.png';
        },
        alternativeImageGridSource(watch) {
            return '/watches/gallery/NW-' + watch.SKU + '/grid-image/custom_grid_image_NW-' + watch.SKU + '.jpg';
        },      
        openPopup(index) {
            this.activePopup = index; // Set the active popup to the clicked item's index
        },
        closePopup() {
            this.activePopup = null; // Close the popup
        },
    },
    computed: {
        displayAppliedFilters() {
        return Object.entries(this.appliedFilters)
            .map(([key, values]) => `${values.join(' ')}`)  
            .join(' ');
        },
    },
    beforeUnmount() {
        if (this.watchesOrderedCancelToken) {
            this.watchesOrderedCancelToken.cancel('Component unmounted, canceling getWatchesRandom request.');
        }
    },

};
</script> -->
